export default __webpack_public_path__ + "static/media/Delhi_1.028db743.png";